export class Standort {
  constructor({
    id,
    name,
    storenummer,
    land,
  }: {
    id: string;
    name: string;
    storenummer: string | undefined;
    land?: string;
  }) {
    this.id = id;
    this.name = name;
    this.storenummer = storenummer;
    this.land = land;
  }

  id: string;
  name: string;
  storenummer: string | undefined;
  land?: string;
}
